export const BASE_URL = 'http://data.europeana.eu';
export const ITEM_URL_PREFIX = `${BASE_URL}/item`;
export const SET_URL_PREFIX = `${BASE_URL}/set`;
